/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import Loading from '_components/Loading';
// routes config
import { routes } from '../../routes';
import DefaultLayout from './DefaultLayout';

const DefaultRouting = (props) => {
  const auth = useSelector((state) => state?.entities?.auth);
  const oidc = useSelector((state) => state.entities.oidc);
  const me = auth?.me;
  const loading = auth?.loading;
  const loggedIn = auth?.loggedIn;
  const error = auth?.error;

  const status = !!oidc?.user && loggedIn;
  const { location: { pathname: path } } = props;

  let mainClass = !loggedIn ? 'ml-0' : '';

  if (path === '/' || path === '/dashboard') {
    mainClass = 'side-root';
  }

  return (
    <div className='app'>
      {loading && <Loading fullscreen />}
      {!loading && (
        <Switch>
          {status && <Redirect exact from='/' to='/dashboard' />}
          {routes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              render={(routeProps) => {
                if (!route.role || (status && route.role.includes(me.role))) {
                  return (
                    <DefaultLayout
                      route={route}
                      {...routeProps}
                      loggedIn={status}
                      mainClass={mainClass}
                    />
                  );
                }
                if (error) {
                  return <Redirect to='/' />;
                }
                if (status) {
                  return <Redirect from='/' to='/401' />;
                }
                return <Redirect from='/' to={`/login?redirect=${path}`} />;
              }}
            />
          ))}
          <Redirect from='/' to='/404' />
        </Switch>
      )}
    </div>
  );
};

export default connect((state) => ({
  oidc: state.entities.oidc,
  auth: state.entities.auth,
}))(DefaultRouting);
